define('drops/calendar/daysofmonthcalendar',[
    'jquery',
    'underscore',
    'globalize',
    'luxon',
    'lq/eventSource',
    'tpl!drops/calendar/daysofmonthcalendar.html',
    'lq/html'
], function ($, _, globalize, luxon, EventSource, template, html) {
    'use strict';

    const { DateTime } = luxon;

    var defaults = {
        standalone: false,
        showWeekdayHeaders: false,
        weekdayHeadersFormat: 'd',
        titleFormat: 'MMMM yyyy',
        languageISOCode: null
    };

    var DaysOfMonthCalendar = function (options) {
        EventSource.call(this, ['Navigated', 'Clicked']);

        this.options = $.extend({}, defaults, options);
        this.selectedDate = null;

        this.$element = $(template());

        var self = this;
        this.$element.find('.previous-page')
            .on('click', function() {
                self.previous();
            });
        this.$element.find('.next-page')
            .on('click', function () {
                self.next();
            });

        this.$title = this.$element.find('.date-as-title');
        this.$days =  this.$element.find('.calendar-days');
        this.$weekdayHeaders = _.map(_.range(1, 8), function () {
            return $('<div />');
        });

        this.$days.append($('<div />')
            .addClass('weekday-headers')
            .append(this.$weekdayHeaders));

        if (!this.options.standalone) {
            this.$element.addClass('no-navigation');
            this.$title.addClass('always-visible');
        }

        this.updateWeekdayHeaders();
        this.toggleWeekdayHeaders();
    };

    DaysOfMonthCalendar.prototype.updateWeekdayHeaders = function () {
        var self = this;
        _.each(this.$weekdayHeaders, function ($weekdayHeader, i) {
            var date = DateTime.now().startOf('week').plus({ days: i });
            var name = globalize.format(
                date.toJSDate(),
                self.options.weekdayHeadersFormat,
                self.options.languageISOCode ? self.options.languageISOCode : undefined);
            $weekdayHeader.text(name);
        });
    };

    DaysOfMonthCalendar.prototype.toggleWeekdayHeaders = function () {
        if (this.options.showWeekdayHeaders)
            this.$element.removeClass('no-weekday-headers');
        else
            this.$element.addClass('no-weekday-headers');
    };

    DaysOfMonthCalendar.prototype.previous = function() {
        this.open(this.date.minus({ months: 1 }));
        this.triggerNavigated();
    };

    DaysOfMonthCalendar.prototype.next = function () {
        this.open(this.date.plus({ months: 1 }));
        this.triggerNavigated();
    };

    DaysOfMonthCalendar.prototype.open = function (date) {
        this.date = date;
        this.rerender();
    };

    DaysOfMonthCalendar.prototype.rerender = function () {
        this.updateTitle();
        this.buildDays();
        this.renderDaysInRowsOfSeven();
    };

    DaysOfMonthCalendar.prototype.updateTitle = function () {
        var title = globalize.format(
            this.date.toJSDate(),
            this.options.titleFormat,
            this.options.languageISOCode ? this.options.languageISOCode : undefined);
        this.$title.text(title);
    };

    DaysOfMonthCalendar.prototype.getOpenDate = function () {
        return this.date;
    };

    DaysOfMonthCalendar.prototype.buildDays = function () {
        this.days = [];

        var start = this.date
            .startOf('month')
            .startOf('week')
            .startOf('day');

        // Always show 6 weeks. This is the only way to make sure the calendar always has the same size.
        var stop = start
            .plus({ weeks: 5 })
            .endOf('week')
            .startOf('day');

        while (start <= stop) {
            var day = this.createDay(start);
            this.days.push(day);

            start = start.plus({ days: 1 });
        }
    };

    DaysOfMonthCalendar.prototype.createDay = function(date) {
        var $day = $('<div />')
            .text(globalize.format(date.toJSDate(), ' d'));
        var today = DateTime.now();

        if (date.hasSame(this.date, 'month')) {
            $day.addClass('this-month');

            if (date.isWeekend)
                $day.addClass('weekend');

            if (date.hasSame(today, 'day'))
                $day.addClass('today');

            if (this.selectedDate && date.hasSame(this.selectedDate, 'day'))
                $day.addClass('selected');

            if (this.hasClickedListeners()) {
                var self = this;
                $day
                    .addClass('clickable')
                    .on('click', function () {
                        if (self.isSelectedDate(date))
                            return;
                        self.setSelectedDate(date);
                        self.triggerClicked(date);
                    });
            }
        } else {
            $day.addClass('another-month');
        }

        return {
            $element: $day,
            dateTime: date
        };
    };

    DaysOfMonthCalendar.prototype.isSelectedDate = function(otherDate) {
        return this.selectedDate && this.selectedDate.equals(otherDate);
    };

    DaysOfMonthCalendar.prototype.renderDaysInRowsOfSeven = function () {
        this.$days
            .children(':not(.weekday-headers)')
            .remove();

        var $days = _.pluck(this.days, '$element');

        while ($days.length) {
            var $row = $days.splice(0, 7);
            this.$days
                .append($('<div />')
                    .addClass('days-of-month')
                    .append($row));
        }
    };

    DaysOfMonthCalendar.prototype.decorateDate = function (date, backgroundColor, fontColor, tooltip, isUnavailable) {
        var visibleDay = this.getDay(date);

        if (visibleDay) {
            if (isUnavailable) {
                visibleDay.$element
                    .addClass('unavailable')
                    .removeClass('clickable')
                    .off('click');
            }

            // in case of the colors, the last one will win
            if (backgroundColor)
                visibleDay.$element.css('background-color', backgroundColor);

            if (fontColor)
                visibleDay.$element.css('color', fontColor);

            // in case of the tooltip we will merge the text if there are multiple events for the same date
            if (tooltip) {
                var title = visibleDay.$element.attr('title');

                if (title)
                    title = title + '\n' + tooltip;
                else
                    title = tooltip;

                visibleDay.$element.attr('title', html.strip(title));
            }
        }
    };

    DaysOfMonthCalendar.prototype.setSelectedDate = function (date) {
        this.clearSelectedDate();

        var visibleDay = this.getDay(date);
        if (visibleDay)
            visibleDay.$element.addClass('selected');

        this.selectedDate = date;
    };

    DaysOfMonthCalendar.prototype.clearSelectedDate = function () {
        if (!this.selectedDate)
            return;

        var visibleDay = this.getDay(this.selectedDate);
        if (visibleDay)
            visibleDay.$element.removeClass('selected');

        this.selectedDate = null;
    };

    DaysOfMonthCalendar.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    DaysOfMonthCalendar.prototype.getDay = function (date) {
        return _.find(this.days, function (day) {
            return day.dateTime.hasSame(date, 'day');
        });
    };

    DaysOfMonthCalendar.prototype.set = function (option, value) {
        if (!this.options.hasOwnProperty(option))
            return;

        this.options[option] = value;

        if (option === 'titleFormat')
            this.updateTitle();
        else if (option === 'showWeekdayHeaders')
            this.toggleWeekdayHeaders();
        else if (option === 'weekdayHeadersFormat')
            this.updateWeekdayHeaders();
    };

    return DaysOfMonthCalendar;


});
